<div class="ngx-mat-tel-input-container">
    <mat-form-field appearance="outline" [ngClass]="classList" 
                    [class.ng-invalid]="required && !phoneNumber"
                    [class.ng-required]="required">
        <mat-label>{{placeholder}}</mat-label>

        <button type="button" mat-button [matMenuTriggerFor]="menu" class="country-selector" [disabled]="disabled"
            [hidden]="!focused && !phoneNumber" 
            [attr.aria-label]="'Select country code'"
            [attr.aria-haspopup]="'menu'"
            [attr.aria-expanded]="false">
            <span class="country-selector-flag flag" [ngClass]="selectedCountry?.flagClass"></span>
            <span class="country-selector-code" *ngIf="selectedCountry?.dialCode">+{{ selectedCountry?.dialCode
                }}</span>
        </button>
        <mat-menu #menu="matMenu" class="ngx-mat-tel-input-mat-menu-panel"
            backdropClass="ngx-mat-tel-input-overlay-backdrop" overlayPanelClass="ngx-mat-tel-input-overlay-pane">

            <button type="button" mat-menu-item class="country-list-button"
                *ngFor="let country of preferredCountriesInDropDown" (click)="onCountrySelect(country, focusable)">
                <div class="icon-wrapper">
                    <div class="flag" [ngClass]="country.flagClass"></div>
                </div>
                <div class="label-wrapper">
                    {{ country.name }}
                    <span *ngIf="country?.dialCode">+{{ country.dialCode }}</span>
                </div>
            </button>
            <mat-divider *ngIf="preferredCountriesInDropDown?.length"></mat-divider>
            <ng-container *ngFor="let country of allCountries">
                <button type="button" mat-menu-item class="country-list-button" *ngIf="country"
                    (click)="onCountrySelect(country, focusable)">
                    <div class="icon-wrapper">
                        <div class="flag" [ngClass]="country.flagClass"></div>
                    </div>
                    <div class="label-wrapper">
                        {{ country.name }} +{{ country.dialCode }}
                    </div>
                </button>
            </ng-container>
        </mat-menu>


        <input matInput type="tel" autocomplete="off" (keypress)="onInputKeyPress($event)" [(ngModel)]="phoneNumber"
            (change)="onPhoneNumberChange()" [placeholder]="inputPlaceholder ? inputPlaceholder : ''" #focusable />
